import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import { api } from '../services/api'
// Ensure all API endpoints are registered at app init
import '../services/usersApi'
import '../services/plansApi'
import '../services/creditsApi'
import '../services/creditAmountApi'
import '../services/communityImagesApi'
import '../services/architectImagesApi'
import '../services/sfxApi'
import '../services/videosApi'
import '../services/promptsApi'
import '../services/popularStylesApi'
import '../services/falModelsApi'
import '../services/moodsApi'
import '../services/defaultSketchImagesApi'
import '../services/defaultWalkthroughModelsApi'
import '../services/generationInstructionTemplatesApi'
import '../services/adminDashboardApi'
import '../services/adminAnalyticsApi'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        [api.reducerPath]: api.reducer,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
